import { render, staticRenderFns } from "./AppsDetail.vue?vue&type=template&id=5087833d&scoped=true"
import script from "./AppsDetail.vue?vue&type=script&lang=js"
export * from "./AppsDetail.vue?vue&type=script&lang=js"
import style0 from "./AppsDetail.vue?vue&type=style&index=0&id=5087833d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5087833d",
  null
  
)

export default component.exports